<template>
  <div>
    <v-dialog
      v-model="enable"
      persistent
      width="1000"
      >
      <v-card
        class="main--text">
        <v-container
          fluid>
          <v-row
            no-gutters
            align=center
            justify=space-between
            >
            <v-col
              cols=auto>
              <h3>リクエスト送信画面</h3>
            </v-col>
            <v-col
              cols=auto>
              <v-icon
                @click="$emit('close-button-click')">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols=12
              md=4
              sm=4
              >
              <v-container
                fluid>
                <v-row
                  justify=center
                  justify-sm=end
                  justify-md=end>
                  <v-col
                    cols=auto>
                  <v-avatar size="120px">
                    <img :src="teacher.iconUrl" alt="">
                  </v-avatar>
                  </v-col>
                </v-row>
                <div>
                  <h3 :class="leftItemsStyle">{{ teacher.fullName() }}</h3>
                  <p :class="leftItemsStyle">
                    {{ teacher.flatFullName() }}<br>
                    {{ teacher.genderInJapanese() }}
                  </p>
                </div>
              </v-container>
            </v-col>
            <v-col
              md=8>
              <v-container
                fluid>
                <h2>担当を希望されるお子さま</h2>
                <v-divider></v-divider>
                <template
                  v-for="student in students.get()">
                  <v-checkbox
                    v-model="selectedStudentIds"
                    :key="student.id"
                    :value="student.id"
                    :label="student.fullName()"></v-checkbox>
                </template>
                <v-row
                  no-gutters
                  justify=end>
                  <v-btn
                    rounded
                    dark
                    outlined
                    depressed
                    color="primary"
                    @click="send"
                    >送信</v-btn>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="sentDialog"
      width="400">
      <v-card
        class="main--text">
        <v-container
          fluid>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              リクエストを送信しました！
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                depressed
                rounded
                outlined
                color="primary"
                @click="sentDialog=false">OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    enable: {
      type: Boolean,
      default: false
    },
    teacher: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      students: this.$store.getters.parent.students,
      selectedStudentIds: [],
      sentDialog: false,
      leftItemsStyle: "text-center text-sm-right text-md-right"
    }
  },
  methods: {
    send: function () {
      if (this.selectedStudentIds.length === 0) {
        throw new Error("No students are selected.")
      }
      this.$emit("send-button-click", this.teacher, this.selectedStudentIds)
      this.sentDialog = true
    }
  }
}
</script>
